import React from "react";
import Link from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";

const RenderAppraisee = ({ appraisee, isAppraiser = false }) => {
    const name = appraisee?.name ?? "Not specified";

    const display =
        isAppraiser && appraisee?.uuid ? (
            <Link
                underline="hover"
                color="inherit"
                component={RouterLink}
                to={`/rms/appraisees/${appraisee.uuid}`}
            >
                {name}
            </Link>
        ) : (
            name
        );

    return display;
};

export default RenderAppraisee;
